import { tap, map, concatMap } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Pagination } from '@core/models/pagination.model';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { AboutUs } from '@core/models/about-us.model';

@Injectable()
export class AboutUsDataService extends DefaultDataService<AboutUs>  {

  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
    super('AboutUs', http, httpUrlGenerator, { root: '' });
  }

  getAll(): Observable<AboutUs[]> {
    return this.http.get<ApiResponse>('/aboutus').pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  add(aboutUsContents: AboutUs): Observable<any>{
    return this.http.post<ApiResponse>(`/aboutus`, aboutUsContents).pipe(
      tap(res => res.message)
    );
  }

  getWithQuery(pageParam: string): Observable<AboutUs[]>{
    return this.http.get<ApiResponse>(`/aboutus${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data)
    )
  }

  getById(id: number): Observable<AboutUs>{
    return this.http.get<ApiResponse>(`/aboutus/${id}`).pipe(
      map(res => res.data.rows)
    );
  }

  getContentTypesStatus(){
    return this.http.get<ApiResponse>('/contenttypesstatus').pipe(
      map(res => res.data.rows)
    );
  }

  getContentTypes(){
    return this.http.get<ApiResponse>(`/contenttypes`).pipe(
      map(res => res.data.rows)
    );
  }

  private paginationInit(res: any) {
    if(res) {
      this.pagination = res.data.contents.paginations;
    }
  }

  updateAboutUsContent(id: number, aboutUs: any) {
    return this.http.put<ApiResponse>(`/aboutus/${id}`, aboutUs).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }
  
  updateStatus(param: any) {
    return this.http.put<ApiResponse>(`/aboutus/statusupdate`, param).pipe(
      tap(res => this.messages$.next(res.message)),
    );
  }

  duplicate(param: any) {
    return this.http.post<ApiResponse>(`/aboutus/duplicate`, param).pipe(
      tap(res => this.messages$.next(res.message)),
    );
  }
}
